import React, { useRef, useState, useEffect } from "react";
import { useRppgModel } from "./rppg/useRppgModel";
import { createRppgCollector } from "./rppg/rppgCollector";
import { extractSkinRGB } from "./rppg/faceROI";
import "./styles.css";

const MAX = 60;        // 30 seconds
const FPS = 30;        // expected camera fps
const REQUIRED_WINDOW = 256;  // must match model

export default function VideoRecorder() {

  const videoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
const chunksRef = useRef([]);
const videoBlobRef = useRef(null);
  const canvasRef = useRef(null);
  const recRef = useRef(false);
  const collectorRef = useRef(null);
  const rppgRef = useRef([]);
  const [consent, setConsent] = useState(false);


  const { model, loading } = useRppgModel();

  const [faceVisible, setFaceVisible] = useState(false);
  const [sec, setSec] = useState(0);
  const [recording, setRecording] = useState(false);

  const [sbp, setSbp] = useState("");
  const [dbp, setDbp] = useState("");
  const [spo2, setSpo2] = useState("");
  const [hr, setHr] = useState("");
  const [sugar, setSugar] = useState("");

  // ================= TIMER =================
  useEffect(() => {
    let interval;

    if (recording) {
      interval = setInterval(() => {
        setSec(prev => prev + 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [recording]);

  // ================= SAVE =================
  const saveDataset = async () => {
    if (!consent) {
      alert("⚠ Consent required before submitting vitals.");
      return;
    }
    console.log("FINAL LENGTH:", rppgRef.current.length);
    console.log(sugar, "0909099090")

    if (!videoBlobRef.current) {
    alert("❌ Video not recorded");
    return;
  }



    if (rppgRef.current.length < REQUIRED_WINDOW) {
      alert("❌ Not enough rPPG signal collected (need 256 samples)");
      return;
    }

      const formData = new FormData();

  formData.append("video", videoBlobRef.current, "sample.webm");
  formData.append("rppg_signal", JSON.stringify(rppgRef.current));

  formData.append("sbp", sbp);
  formData.append("dbp", dbp);
  formData.append("spo2", spo2);
  formData.append("heart_rate", hr);
  formData.append("respiratory_rate", sugar);


    // const payload = {
    //   formData.append("video", videoBlobRef.current, "sample.webm");
    //   rppg_signal: [...rppgRef.current],
    //   sbp: Number(sbp),
    //   dbp: Number(dbp),
    //   spo2: Number(spo2),
    //   heart_rate: Number(hr),
    //   respiratory_rate: Number(sugar),
    //   captured_at: new Date().toISOString()
    // };

    try {
      const res = await fetch(
        "https://www.careplus.gopillz.com/upload-vitals",
        {
          method: "POST",
         body: formData
        }
      );

      if (!res.ok) throw new Error("API failed");

      alert("✅ Dataset saved successfully");

      rppgRef.current = [];
      setSbp(""); setDbp(""); setSpo2(""); setHr(""); setSugar("");

    } catch (err) {
      console.error(err);
      alert("❌ Failed to save dataset");
    }
  };

  // ================= START =================
  const start = async () => {

    chunksRef.current = [];   // reset before recording
    if (!model || loading) {
      alert("Model not ready yet");
      return;
    }

    rppgRef.current = [];
    setSec(0);

    const stream = await navigator.mediaDevices.getUserMedia({
      video: { frameRate: 30 }
    });

    videoRef.current.srcObject = stream;

    await new Promise(resolve => {
      videoRef.current.onloadedmetadata = () => {
        videoRef.current.play();
        resolve();
      };
    });

    const mediaRecorder = new MediaRecorder(stream, {
    mimeType: "video/webm"
  });

  mediaRecorder.ondataavailable = (e) => {
    if (e.data.size > 0) {
      chunksRef.current.push(e.data);
    }
  };

  mediaRecorder.start();
  mediaRecorderRef.current = mediaRecorder;

    recRef.current = true;
    setRecording(true);

    collectorRef.current = createRppgCollector(
      model,
      (value) => {
        if (value !== null && value !== undefined) {
          rppgRef.current.push(value);
        }
      }
    );

    loop();


    setTimeout(() => {
      if (recRef.current) {
        stop();
        console.log("⏰ Auto stopped after 60 seconds");
      }
    }, MAX * 1000);

    // setTimeout(stop, MAX * 1000);
  };

  // ================= LOOP =================
  const loop = async () => {

    if (!recRef.current) return;

    const video = videoRef.current;

    if (!video || video.readyState !== 4) {
      requestAnimationFrame(loop);
      return;
    }

    const rgb = await extractSkinRGB(video, canvasRef.current);

    if (!rgb) {
      setFaceVisible(false);
      requestAnimationFrame(loop);
      return;
    }

    setFaceVisible(true);

    if (collectorRef.current) {
      collectorRef.current(rgb);
    }

    requestAnimationFrame(loop);
  };

  // ================= STOP =================
  const stop = async () => {

    recRef.current = false;

    videoRef.current?.srcObject?.getTracks().forEach(t => t.stop());

    if (mediaRecorderRef.current) {
    await new Promise(resolve => {
      mediaRecorderRef.current.onstop = () => {
        videoBlobRef.current = new Blob(chunksRef.current, {
          type: "video/webm"
        });
        resolve();
      };
      mediaRecorderRef.current.stop();
    });
  }


    setRecording(false);

    console.log("RGB BUFFER LENGTH:",
  collectorRef.current?.getRGBLength()
);

console.log("🎥 Video size:", videoBlobRef.current?.size);
  console.log("📊 rPPG length:", rppgRef.current.length);

console.log("rPPG OUTPUT LENGTH:",
  rppgRef.current.length
);


  };

  // ================= UI =================
  return (
    <div className="page">
      <div className="card">

        <h2>Remote Vital Capture</h2>

        {!faceVisible && recording && (
          <div className="face-warning">
            ⚠ Move face closer · Good lighting · Stay still
          </div>
        )}

        <div className="video-box">
          <video ref={videoRef} autoPlay muted playsInline />
          {/* <div className="timer">{MAX}s</div> */}
        </div>

        <canvas ref={canvasRef} width={128} height={128} hidden />

        {!recording ? (
          <button
            className="btn primary"
            disabled={!model || loading}
            onClick={start}
          >
            ▶ Start 60s Capture
          </button>
        ) : (
          <button className="btn danger" onClick={stop}>
            ⏹ Stop
          </button>
        )}

        <div className="form">
          <h3>Doctor / Nurse Entry</h3>

          <div className="grid">
            <input placeholder="Systolic BP"
              value={sbp}
              onChange={e => setSbp(e.target.value.replace(/\D/g, ""))} />

            <input placeholder="Diastolic BP"
              value={dbp}
              onChange={e => setDbp(e.target.value.replace(/\D/g, ""))} />

            <input placeholder="SpO₂"
              value={spo2}
              onChange={e => setSpo2(e.target.value.replace(/\D/g, ""))} />

            <input placeholder="Heart Rate"
              value={hr}
              onChange={e => setHr(e.target.value.replace(/\D/g, ""))} />

            <input placeholder="Respiratory Rate - Optional"
              value={sugar}
               min="0"
              onChange={e => setSugar(e.target.value.replace(/\D/g, ""))} />
          </div>

          <button className="btn primary full" onClick={saveDataset}>
            Save Dataset
          </button>
        </div>
        <div className="consent-box">
  <label className="consent-label">
    <input
      type="checkbox"
      checked={consent}
      onChange={(e) => setConsent(e.target.checked)}
    />
    I give my consent for video capture and vitals submission.
  </label>
</div>
      </div>
    </div>
  );
}


// import React,{useRef,useState} from "react";
// import { startCamera } from "./rppg/camera";
// import { extractSkinRGB } from "./rppg/faceROI";
// import { createRppgCollector } from "./rppg/rppgCollector";

// export default function VideoRecorder(){

//   const videoRef=useRef(null);
//   const canvasRef=useRef(null);
//   const collectorRef=useRef(null);
//   const recRef=useRef(false);

//   const [hr,setHr]=useState(null);

//   const start=async()=>{

//     await startCamera(videoRef);

//     collectorRef.current=createRppgCollector((value)=>{
//       console.log(value)
//       setHr(Math.round(value));
//     });

//     recRef.current=true;
//     loop();
//   };

//   const loop=async()=>{

//     if(!recRef.current) return;

//     const rgb=await extractSkinRGB(
//       videoRef.current,
//       canvasRef.current
//     );

//     console.log(rgb,"=-=-=-=-")

//     if(rgb){
//       collectorRef.current?.(rgb);
//     }

//     requestAnimationFrame(loop);
//   };

//   return(
//     <div>
//       <video ref={videoRef} autoPlay muted playsInline/>
//       <canvas ref={canvasRef} width={128} height={128} hidden/>

//       <button onClick={start}>Start</button>

//       <h2>HR: {hr? hr+" BPM":"--"}</h2>
//     </div>
//   );
// }
